import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, mediaUrl } from "../lib/api";
import { Avatar, Loading, Empty, formatNum } from "../components/common";
import { ProductCard } from "../components/marketui";
import { ProductDetail } from "./Marketplace";
import { Store, BadgeCheck, Package } from "lucide-react";

export default function Storefront() {
  const { handle } = useParams();
  const username = (handle || "").replace(/^@/, "");
  const [data, setData] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => { setData(null); api.get(`/marketplace/store/${username}`).then(({ data }) => setData(data)).catch(() => setData(false)); }, [username]);

  if (data === null) return <Loading />;
  if (data === false) return <Empty title="Store not found" />;
  const s = data.seller;

  return (
    <div className="px-4 md:px-6 py-5 max-w-[1100px] mx-auto" data-testid="storefront-page">
      <div className="surface rounded-2xl p-5 flex items-center gap-4 mb-6">
        <Avatar src={s?.avatar_url} name={s?.display_name} size={72} />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h1 className="font-display font-bold text-xl truncate">{s?.display_name}</h1>
            {data.is_seller && <span className="text-[10px] bg-gold/15 text-gold border border-gold/40 rounded-full px-2 py-0.5 flex items-center gap-1 font-semibold"><BadgeCheck size={11} />VirtuStars+ Seller</span>}
          </div>
          <Link to={`/${s?.username}`} className="text-sm text-muted-foreground hover:text-eblue">@{s?.username}</Link>
          {s?.bio && <p className="text-sm mt-1 line-clamp-2">{s.bio}</p>}
          <div className="flex gap-4 mt-2 text-xs text-muted-foreground"><span><b className="text-white">{data.product_count}</b> products</span><span><b className="text-white">{formatNum(data.total_sold)}</b> sold</span></div>
        </div>
        <Store className="text-gold hidden md:block" size={28} />
      </div>

      {data.products.length === 0 ? (
        <Empty icon={Package} title="No products yet" hint="This creator hasn't listed any products." />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">{data.products.map((p) => <ProductCard key={p.id} p={p} onOpen={setDetail} testid={`storefront-product-${p.id}`} />)}</div>
      )}

      {detail && <ProductDetail pid={detail.id} onClose={() => setDetail(null)} onChange={() => api.get(`/marketplace/store/${username}`).then(({ data }) => setData(data))} />}
    </div>
  );
}
